/* eslint-disable react-hooks/exhaustive-deps */
// @vendors
import React, { useEffect } from "react";

// @components
import ActiveServices from "../../pages/myServices/components/ActiveServices";
import CompletedServices from "../../pages/myServices/components/CompletedServices";
import CanceledService from "./components/CanceledService";

// @store
import useServiceRequestStore from '../../store/useServiceRequestStore';
import { useSpinnerStore } from "../../store/useSpinnerStore";

// @types
import { IParamsServiceReques, ServiceRequest } from "../../types/request.types";

const MyServicesPage: React.FC = () => {
  const { openSpinner } = useSpinnerStore();
  const { isLoading, requestListByStatus, serviceList } = useServiceRequestStore();

  useEffect(() => {
    if (isLoading) return openSpinner(true);
    return openSpinner(false);
  }, [isLoading])

  useEffect(() => {
    const params: IParamsServiceReques = {
      statusList: [1, 2, 3, 6],
      categoryId: '',
      createdByMe: true
    }
    requestListByStatus(params);
  }, [requestListByStatus]);

  const activeServices = serviceList?.items?.filter((service: ServiceRequest) => service.serviceRequestStatus === 1 || service.serviceRequestStatus === 6) || [];
  const completeServices = serviceList?.items?.filter((service: ServiceRequest) => service.serviceRequestStatus === 2) || [];
  const cancelledServices = serviceList?.items?.filter((service: ServiceRequest) => service.serviceRequestStatus === 3) || [];

  return (
    <div className="w-full m-auto p-6 space-y-5">
      <ActiveServices services={activeServices} />
      <CompletedServices services={completeServices} />
      <CanceledService services={cancelledServices} />
    </div>
  );
};

export default MyServicesPage;
